import React, { useState, useEffect } from "react";
import "./addDepartmentPrice.css";
import ToastPopup from "../../widgets/Toast/toastPopup";
import Widgets from "../../widgets";
import ClockIcon from "../../Assets/Icons/Clock.png";
import useValidation from "../../utils/validators";
import { useTranslation } from "react-i18next";
import { getAllDepartments, updateDepartmentPrice, getAllDepPrice } from "../../modules/department/departmentThunk";
import { useDispatch, useSelector } from "react-redux";
import { resetUpdateDepPrice, resetGetAllDepartment, resetGetDepPrice } from "../../modules/department/departmentSlice";

const AddDepartmentPrice = ({ setSelectedView }) => {
  const dispatch = useDispatch();
  const breadcrumbs = ["video_Consultation", "depPriceDetails"];
  const paths = [{ path: "/department-price", onClick: () => setSelectedView("departmentPrice") }, "/department-price"];
  const [name, setName] = useState("");
  const [duration, setDuration] = useState(""); // Store raw duration value (e.g., "30")
  const [grade, setGrade] = useState("");
  const [opdInternational, setOpdInternational] = useState("");
  const [opdLocal, setOpdLocal] = useState("");
  const [opdSubsidized, setOpdSubsidized] = useState("");
  const { validateDepartmentPrice } = useValidation();
  const selectedLanguage = useSelector((state) => state.language.language);
  const { t } = useTranslation();
  const { updateDepPriceSuccess, updateDepPriceErr, getAllDepartmentError, getAllDepartment, getDepPriceSuccess, getDepPriceErr } = useSelector((state) => state.department);
  const [depOption, setDepOption] = useState([]);
  const [durationOption, setDurationOption] = useState([]); // Store raw duration values (e.g., [30, 45, 60])
  const [gradeOption, setGradeOption] = useState([]);
  const [priceList, setPriceList] = useState({});
  const [priceCode, setPriceCode] = useState("");
  const [matchedPriceList, setMatchedPriceList] = useState({});

  useEffect(() => {
    if (updateDepPriceErr) {
      ToastPopup.error(updateDepPriceErr);
    }
    if (updateDepPriceSuccess && updateDepPriceSuccess.status === "success") {
      ToastPopup.success(t("depUpdated"));
      setSelectedView("departmentPrice");
    }
    dispatch(resetUpdateDepPrice());
  }, [updateDepPriceSuccess, updateDepPriceErr]);

  useEffect(() => {
    if (getAllDepartmentError) {
      ToastPopup.error(getAllDepartmentError);
    }
    if (getAllDepartment && getAllDepartment.status === "success") {
      setDepOption(
        getAllDepartment.data.departments
          .filter((department) => department.isActive)
          .map((department) => (selectedLanguage === "vietnam" ? department.departmentName.vi : department.departmentName.en)),
      );
      if (name) {
        const matchedDepartment = getAllDepartment.data.departments.find((department) => department.departmentName.en === name || department.departmentName.vi === name);
        if (matchedDepartment) {
          setName(selectedLanguage === "vietnam" ? matchedDepartment.departmentName.vi : matchedDepartment.departmentName.en);
        }
      }
    }
    dispatch(resetGetAllDepartment());
  }, [getAllDepartment, getAllDepartmentError, selectedLanguage]);

  useEffect(() => {
    if (getDepPriceErr) {
      ToastPopup.error(getDepPriceErr);
    }
    if (getDepPriceSuccess && getDepPriceSuccess.status === "success") {
      setPriceList(getDepPriceSuccess.data.prices);
      const durations = [...new Set(getDepPriceSuccess.data.prices.map((item) => item.duration))];
      setDurationOption(durations); // Store raw duration values (e.g., [30, 45, 60])
      setGradeOption([...new Set(getDepPriceSuccess.data.prices.map((item) => item.grade))]);
    }
    dispatch(resetGetDepPrice());
  }, [getDepPriceSuccess, getDepPriceErr]);

  useEffect(() => {
    const page = 1;
    const limit = 9999;
    const sort = "departmentName";
    const searchFields = "";
    const search = "";
    const fields = "departmentName,isActive";
    dispatch(getAllDepartments({ page, limit, sort, searchFields, search, fields }));
  }, [selectedLanguage]);

  useEffect(() => {
    if (name && duration && grade) {
      const durationNumber = duration; // Use raw duration value
      const matchedPrice = priceList.find((item) => (item.departmentName.en === name || item.departmentName.vi === name) && item.duration === durationNumber && item.grade === grade);
      if (matchedPrice) {
        setPriceCode(matchedPrice.priceCode);
        setMatchedPriceList(matchedPrice);
        if (matchedPrice.price) {
          setOpdInternational(matchedPrice.price.opdInternational.replace(/\B(?=(\d{3})+(?!\d))/g, ","));
          setOpdLocal(matchedPrice.price.opdLocalPrice.replace(/\B(?=(\d{3})+(?!\d))/g, ","));
          setOpdSubsidized(matchedPrice.price.opdSubsidized.replace(/\B(?=(\d{3})+(?!\d))/g, ","));
        } else {
          setOpdInternational("");
          setOpdLocal("");
          setOpdSubsidized("");
        }
      } else {
        setPriceCode("");
      }
    }
  }, [name, duration, grade, priceList]);

  const handleCancel = () => {
    setSelectedView("departmentPrice");
  };

  const handleSave = () => {
    const selectedData = {
      name,
      duration,
      grade,
      code: priceCode,
      opdInternational,
      opdLocal,
      opdSubsidized,
    };
    if (validateDepartmentPrice(selectedData)) {
      const hasChanges = matchedPriceList.price?.opdInternational !== opdInternational || matchedPriceList.price?.opdLocalPrice !== opdLocal || matchedPriceList.price?.opdSubsidized !== opdSubsidized;

      if (hasChanges) {
        const body = {
          priceCode: priceCode,
          opdInternationalPrice: opdInternational.replace(/,/g, ""),
          opdLocalPrice: opdLocal.replace(/,/g, ""),
          opdSubsidized: opdSubsidized.replace(/,/g, ""),
        };
        dispatch(updateDepartmentPrice(body));
      } else {
        ToastPopup.error(t("noChanges"));
      }
    }
  };

  const handleNameChange = (selectedName) => {
    if (name === selectedName) {
      return;
    }
    setName(selectedName);
    setGrade("");
    setDuration("");
    setPriceCode("");
    setOpdInternational("");
    setOpdSubsidized("");
    setOpdLocal("");
    const page = 1;
    const limit = 9999;
    const search = selectedName;
    const searchFields = selectedLanguage === "vietnam" ? "departmentName.vi,priceCode" : "departmentName.en,priceCode";
    dispatch(getAllDepPrice({ page, limit, search, searchFields }));
  };

  const handleNumericInput = (e, setState) => {
    const inputElement = e.target;
    const { value, selectionStart } = inputElement;
    let rawValue = value.replace(/[^0-9.]/g, "");
    const decimalCount = (rawValue.match(/\./g) || []).length;
    if (decimalCount > 1) {
      rawValue = rawValue.slice(0, rawValue.lastIndexOf("."));
    }
    if (rawValue.startsWith(".")) {
      rawValue = "";
    }
    if (rawValue.startsWith("0") && !rawValue.startsWith("0.")) {
      rawValue = rawValue.replace(/^0+/, "");
    }

    const insertCommas = (str) => str.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    let [integerPart, decimalPart] = rawValue.split(".");
    if (integerPart) {
      integerPart = insertCommas(integerPart);
    }
    const formattedValue = decimalPart !== undefined ? `${integerPart}.${decimalPart}` : integerPart;

    const initialIntegerPart = value.split(".")[0] || "";
    const originalCommas = (initialIntegerPart.slice(0, selectionStart).match(/,/g) || []).length;
    const newCommas = (integerPart.slice(0, selectionStart + integerPart.length - initialIntegerPart.length).match(/,/g) || []).length;
    const cursorOffset = newCommas - originalCommas;
    setState(formattedValue);
    requestAnimationFrame(() => {
      inputElement.setSelectionRange(selectionStart + cursorOffset, selectionStart + cursorOffset);
    });
  };

  // Translate duration options and selected duration
  const getTranslatedDuration = (duration) => {
    return `${duration} ${t("min")}`;
  };

  return (
    <div className="dpa-primary">
      <Widgets.BreadCrumb breadcrumbs={breadcrumbs} paths={paths} />
      <div className="department-heading">{priceCode ? priceCode : t("createDepPrice")}</div>
      <div className="dp-create-price">
        <div className="dp-price-body">
          <p className="dp-body-h1">
            {t("setDepPrice")}
            <span className="astrik">*</span>
          </p>
          <div className="dp-department">
            <div className="dp-box-price">
              <div className="dp-item-row">
                <div className="dp-box-item">
                  {t("name")}
                  <Widgets.SelectDropdown
                    options={depOption}
                    selectedValue={name}
                    onChange={handleNameChange}
                    placeholder="selectName"
                    backgroundColor="var(--bg-select-green)"
                    textColor="var(--color-green)"
                  />
                </div>
                <div className="divider" />
                <div className="dp-box-item">
                  {t("duration")}
                  <Widgets.SelectDropdown
                    options={durationOption.map(getTranslatedDuration)} // Translate options
                    selectedValue={duration ? getTranslatedDuration(duration) : ""} // Translate selected value
                    onChange={(value) => setDuration(value.replace(/\D/g, ""))} // Store raw value
                    placeholder="selectDuration"
                    extraIcon={ClockIcon}
                    backgroundColor="var(--bg-select-green)"
                    textColor="var(--color-green)"
                  />
                </div>
                <div className="divider" />
                <div className="dp-box-item">
                  {t("grade")}
                  <Widgets.SelectDropdown
                    options={gradeOption}
                    selectedValue={grade}
                    onChange={setGrade}
                    placeholder="selectGrade"
                    backgroundColor="var(--bg-select-green)"
                    textColor="var(--color-green)"
                  />
                </div>
              </div>
              <div className="divider last" />
              <div className="dp-box-item id">{priceCode ? priceCode : "- - - / -"}</div>
            </div>
            <div className="dp-price-opd">
              <div className="dp-boxes">
                <p>OPD International Insured</p>
                <div>
                  <span>₫</span>
                  <input type="text" placeholder="0" value={opdInternational} onChange={(e) => handleNumericInput(e, setOpdInternational)} />
                </div>
              </div>
              <div className="dp-boxes">
                <p>OPD Local Insured</p>
                <div>
                  <span>₫</span>
                  <input type="text" placeholder="0" value={opdLocal} onChange={(e) => handleNumericInput(e, setOpdLocal)} />
                </div>
              </div>
              <div className="dp-boxes">
                <p>OPD Subsidized</p>
                <div>
                  <span>₫</span>
                  <input type="text" placeholder="0" value={opdSubsidized} onChange={(e) => handleNumericInput(e, setOpdSubsidized)} />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="save-speciality dp-price-footer">
          <div className="speciality-cancel" onClick={handleCancel}>
            {t("cancel")}
          </div>
          <div className="speciality-save" onClick={handleSave}>
            {t("save")}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddDepartmentPrice;
